import { render, staticRenderFns } from "./OcrImageUploader.vue?vue&type=template&id=69b4b1d4"
import script from "./OcrImageUploader.vue?vue&type=script&lang=js"
export * from "./OcrImageUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports